module.exports = __webpack_public_path__ + "img/logo-fictoan-small.b7d328c8.svg";